import { useEffect, useState } from "react";
import { type Output } from "valibot";

import { requestBackend } from "shared/request";

import { InstalledApps } from "./schemas";

function useInstalledApps(token: string) {
  const [installedApps, setInstalledApps] =
    useState<Output<typeof InstalledApps>>();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    requestBackend("/v1/botsonic/widget/installed-apps-info", {
      headers: {
        token,
      },
      schema: InstalledApps,
    })
      .then(installedApps => {
        setInstalledApps(installedApps);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  return {
    installedApps,
    loading,
  };
}

export default useInstalledApps;
